<app-toggle-field
  *ngIf="viewableAsPdf && !!renderableEntity"
  class="view-as-pdf-toggle"
  [label]="'ACTION.VIEW_AS_PDF' | translate"
  fieldId="view_as_pdf_field"
  [fieldControl]="viewAsPdfFormControl"
  [trackingObject]="trackingObject"
  trackingIdentifier="view_as_pdf"
  [trackingScreenName]="trackingScreenName"
>
</app-toggle-field>

<div #previewContainer id="renderable-entity-container">
  <div
    *ngIf="!renderableEntity || (loading$ | async)"
    class="loading-preview-container"
  >
    <div class="icon-wrapper">
      <app-icon class="loading-spinner" [icon]="loadingSpinnerIcon"> </app-icon>
    </div>
    <div class="loading-message">
      {{ 'LABEL.LOADING_PREVIEW' | translate }}
    </div>
  </div>

  <div
    #htmlPreview
    class="html-preview"
    [hidden]="
      !viewableAsHtml ||
      viewAsPdfFormControl.value ||
      !renderableEntity ||
      (loading$ | async)
    "
  >
    <div class="page-placeholder"></div>
  </div>

  <ng-container *ngIf="viewableAsPdf" [ngSwitch]="pdfRenderingFailed$ | async">
    <ng-container *ngSwitchCase="true">
      <div
        *ngIf="documentType && !!renderableEntity && !(loading$ | async)"
        class="pdf-rendering-error"
      >
        <app-icon class="pdf-not-found-icon" [icon]="pdfNotFoundIcon">
        </app-icon>

        <h2 class="pdf-rendering-error-header">
          {{ 'LABEL.OOPS' | translate }}
        </h2>

        <p class="pdf-rendering-error-description">
          {{
            'DOCUMENT.' + documentType + '.RENDERING.HAVING_TROUBLE_FINDING'
              | uppercase
              | translate
          }}
        </p>

        <hr class="separator" />

        <p
          [innerHTML]="
            'DOCUMENT.' + documentType + '.RENDERING.FIND_ORIGINAL_PDF'
              | uppercase
              | translate: { docNumber: documentNumber }
              | safe: 'html'
          "
          class="pdf-rendering-error-prompt"
        ></p>

        <button
          type="button"
          class="generate-new-pdf-action"
          trackable
          [trackingObject]="trackingObject"
          [trackingAction]="generateNewPdfTrackingAction"
          (click)="reRenderPdf()"
        >
          {{
            'DOCUMENT.' + documentType + '.RENDERING.GENERATE_NEW_PDF'
              | uppercase
              | translate
          }}
        </button>
      </div>
    </ng-container>

    <iframe
      *ngSwitchDefault
      class="pdf-preview"
      [attr.src]="pdfUrl | safe: 'url'"
      type="application/pdf"
      [hidden]="
        !viewAsPdfFormControl.value || !renderableEntity || (loading$ | async)
      "
    >
    </iframe>
  </ng-container>
</div>
